/**
 * Get strings from the WordPress localization object.
 */

type Strings = {
	[index: string]: string | Strings;
};

function resolveString(strings: Strings, path: string[]): string | null {
	if (path.length === 0) {
		return null;
	}

	const [part, ...rest] = path;
	const current = strings[part];

	if (typeof current === 'string') {
		return current;
	}

	if (current === undefined) {
		return null;
	}

	return resolveString(current, rest);
}

export function getString(key: string, fallback: string) {
	const path = key.split('.');
	const string = resolveString(globalThis.p5Strings, path);

	if (string === null || string === '') {
		return fallback;
	}

	return string;
}
